import {
    HomepageTrendingSearchExperiment,
    TrendingSearchValues,
    useGetStatsigEnrollment,
} from '@eventbrite/discover-utils';
import { TrendingChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import { Typography } from '@eventbrite/marmalade';
import React, { useState } from 'react';
import { TrackableComponent } from '../../../../utils/TrackableComponent';
import { useTrendingSearches } from '../../hooks/TrendingSearch';
import styles from './TrendingSearch.module.scss';

interface TrendingSearchProps {
    locationSlug: string | undefined;
    currentPlace: string | undefined;
}

export const TrendingSearch = (props: TrendingSearchProps) => {
    const { locationSlug, currentPlace } = props;
    const trendingSuggestions = useTrendingSearches(locationSlug ?? '');
    const [enableStatsig, setEnableStatsig] = useState(false);
    const title = gettext('Trending searches in %(currentPlace)s', {
        currentPlace: currentPlace ?? '',
    });
    const homepageTrendingSearchExperimentVariant = useGetStatsigEnrollment({
        name: HomepageTrendingSearchExperiment.name,
        paramName: HomepageTrendingSearchExperiment.paramName,
        defaultValue: HomepageTrendingSearchExperiment.values.control,
        enabled: enableStatsig,
    });

    const HandleIntersect = () => {
        setEnableStatsig(true);
    };

    const TrendingSearchComponent = () => (
        <div className={styles.trendingSearch}>
            <Typography className={styles.title} variant="heading-sm">
                {title} <TrendingChunky width="32px" height="32px" />
            </Typography>
            <div className={styles.searchesDiv}>
                {trendingSuggestions.slice(0, 12).map((search, index) => (
                    <a
                        key={index}
                        className={styles.searchItem}
                        data-heap-id={`homepage-trending-search-${search.term}`}
                        href={`/d/${locationSlug}/${search.term}`}
                    >
                        <Typography variant="body-md-bold">
                            {search.term}
                        </Typography>
                    </a>
                ))}
            </div>
        </div>
    );

    if (!trendingSuggestions) return null;
    return (
        <TrackableComponent onIntersect={HandleIntersect} threshold={0.1}>
            {homepageTrendingSearchExperimentVariant.status == 'loading' ? (
                <LoadingSkeleton height={'100px'} />
            ) : (
                homepageTrendingSearchExperimentVariant.variant ==
                    TrendingSearchValues.test && <TrendingSearchComponent />
            )}
        </TrackableComponent>
    );
};
